import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ns-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  adminEmail: string;
  constructor() { }

  ngOnInit() {
    this.adminEmail = (<any>window).external_configuration.adminEmail
  }

}
